import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {KeycloakService} from './keycloak.service';

@Injectable({providedIn: 'root'})
export class AuthService {
    private _kc = inject(KeycloakService);

    private _isAuthenticated$ = new BehaviorSubject<boolean>(false);
    public isAuthenticated$: Observable<boolean> = this._isAuthenticated$.asObservable();

    /** Called once by APP_INITIALIZER after keycloak.init() resolves. */
    notifyAuthState(authenticated: boolean): void {
        this._isAuthenticated$.next(authenticated);
    }

    /** @deprecated use isAuthenticated$ */
    isLogged(): boolean {
        return this._kc.isLoggedIn;
    }

    logout(): void {
        this._kc.logout();
    }
}
